/* Patagonia Café — compléments 15-10 (accueil).
   1. Cartes des cafés : nom sur une ligne, origine sur la suivante.
   2. Carte « Abonnement café » : photo de la box d'abonnement (la même que sur la page Abonnement).
   3. Étapes « Vous choisissez / Nous préparons / Vous savourez » : les pictos sont recadrés pour ne plus montrer les numéros. */
(() => {
  'use strict';
  document.querySelectorAll('.pc3-card h3').forEach(h => {
    if (h.querySelector('.pc3-card__sub')) return;
    const parts = h.textContent.split(/\s[—–-]\s/);
    if (parts.length !== 2) return;
    h.textContent = '';
    h.append(parts[0].trim());
    const sub = document.createElement('span');
    sub.className = 'pc3-card__sub';
    sub.textContent = parts[1].trim();
    h.appendChild(sub);
  });

  const box = 'https://cdn.shopify.com/s/files/1/0886/8351/2151/files/abonnement-cafe-box-1410.jpg?v=1791992312';
  document.querySelectorAll('.pc-choice__card--subscription img.pc-choice__scene').forEach(img => {
    img.srcset = box + '&width=700 700w, ' + box + '&width=1400 1400w';
    img.src = box + '&width=1400';
    img.width = 1400;
    img.height = 1050;
    img.alt = 'Box d’abonnement Patagonia Café ouverte avec trois cafés de sélection';
  });

  /* 4. Nos cafés sur mobile : la mise en page mobile masque les autres sections.
        Le dépliant « Quelques repères » reste utile : on le replace en fin de page. */
  const guide = document.querySelector('.shopify-section:has(.pc-mix__faq--guide)');
  const main = document.querySelector('main');
  let guideHome = null;
  const placeGuide = () => {
    if (!guide || !main || !main.querySelector('.pcm-page')) return;
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    if (mobile) {
      if (!guideHome) {
        guideHome = document.createComment('pc-guide-position');
        guide.before(guideHome);
      }
      if (guide !== main.lastElementChild) main.appendChild(guide);
    } else if (guideHome) {
      guideHome.replaceWith(guide);
      guideHome = null;
    }
  };
  placeGuide();
  window.matchMedia('(max-width: 749px)').addEventListener('change', placeGuide);

  const crop = () => {
    document.querySelectorAll('.pc-choice__step-image').forEach(svg => {
      if (svg.dataset.pchCropped) return;
      const [x, y, w, h] = svg.getAttribute('viewBox').split(' ').map(Number);
      svg.setAttribute('viewBox', [x + 18, y + 16, w - 18, h - 16].join(' '));
      svg.dataset.pchCropped = '1';
    });
  };
  crop();
})();
